export enum BudgetErrorType {
  OverMaxMonthly,
  UnderMinCashDown,
  OverMaxPrice,
  UnderMinPrice
}

// Invalid is never actually displayed and is only used to keep proper spacing.
export enum BudgetErrorMessages {
  OverMaxMonthly = 'You entered an amount above your maximum.',
  UnderMinCashDown = 'You entered an amount below your minimum.',
  OverMaxPrice = 'You entered an amount above the max price',
  UnderMinPrice = 'You entered an amount below the min price',
  Invalid = 'You entered an invalid amount for the selected input'
}

export enum BudgetFilterKeys {
  Finance = 'finance',
  Price = 'price'
}

export enum RangeType {
  Min = 'min',
  Max = 'max',
  DownPayment = 'downPayment',
  MonthlyPayment = 'monthlyPayment'
}
